import { useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";

// I modali dell'app usano <dialog>.showModal(), che promuove il dialog al
// "top layer" del browser: qualsiasi elemento normale (incluso il container
// dei toast) resta sotto, a prescindere dal suo z-index. Promuoviamo anche
// il container dei toast al top layer via Popover API, e lo ri-promuoviamo
// (hide+show) ad ogni nuovo toast per riportarlo in cima allo stack del top
// layer, sopra eventuali dialog aperti dopo di lui.
const ToastManager = () => {
  const popoverHostRef = useRef(null);

  useEffect(() => {
    const host = popoverHostRef.current;
    if (!host || typeof host.showPopover !== "function") return; // browser senza Popover API: fallback allo stacking normale

    host.showPopover();

    const unsubscribe = toast.onChange((toastItem) => {
      // host può essere già stato smontato (es. navigate() dopo logout) quando
      // questo callback si esegue: showPopover su un elemento disconnesso lancia.
      if (toastItem.status === "added" && host.isConnected) {
        host.hidePopover();
        host.showPopover();
      }
    });

    return unsubscribe;
  }, []);

  return (
    <div
      ref={popoverHostRef}
      popover="manual"
      style={{
        position: "fixed",
        inset: 0,
        width: 0,
        height: 0,
        margin: 0,
        padding: 0,
        border: "none",
        background: "none",
        overflow: "visible",
      }}
    >
      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        limit={3}
      />
    </div>
  );
};

export default ToastManager;
